// frontend/src/components/SortableBlockRow.js
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faGripVertical } from '@fortawesome/free-solid-svg-icons';

export const SortableBlockRow = ({ block, handleShowEditModal, handleDeleteClick }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: block.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    };

    return (
        <tr ref={setNodeRef} style={style} {...attributes}>
            <td className="text-center align-middle">
                <button {...listeners} style={{ cursor: 'grab', border: 'none', background: 'transparent', touchAction: 'none' }}>
                    <FontAwesomeIcon icon={faGripVertical} />
                </button>
            </td>
            <td className="align-middle">
                {block.title}
                <div className="small text-muted d-md-none">{block.block_type}</div>
                <Badge bg={block.is_active ? 'success' : 'danger'} className="d-md-none mt-1">
                    {block.is_active ? 'Attivo' : 'Non Attivo'}
                </Badge>
            </td>
            <td className="align-middle d-none d-md-table-cell">{block.block_type}</td>
            <td className="align-middle d-none d-md-table-cell">
                <Badge bg={block.is_active ? 'success' : 'danger'}>
                    {block.is_active ? 'Attivo' : 'Non Attivo'}
                </Badge>
            </td>
            <td className="align-middle text-nowrap">
                <Button variant="warning" size="sm" className="me-2" onClick={() => handleShowEditModal(block)}>
                    <FontAwesomeIcon icon={faEdit} />
                </Button>
                <Button variant="danger" size="sm" onClick={() => handleDeleteClick(block)}>
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </td>
        </tr>
    );
};
